import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
/**
 * @author chenjizhong
 * @fileoverview 轮播
 */
// import _ from "lodash";
import { defineComponent, onMounted, watch, reactive, nextTick } from "vue";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import PreviewDialog from "@/components/common/preview-dialog.vue";
import MemberList from "@/components/m/member-list/member-list.vue";
import lineUrl from "@/assets/img/race-honors/m/line-bottm.png";
// components
export default defineComponent({
  name: "MHonorSwiperBox",
  props: {
    // 轮播信息
    swiperSetInfo: {
      type: Object,
      default: null
    },
    zone1Teams: {
      type: Array,
      default() {
        return [];
      }
    },
    groupType: {
      type: Object,
      default() {
        return {};
      }
    },
    raceQuarter: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  setup(props) {
    const state = reactive({
      mySwiper: null,
      showPreview: false,
      currentIndex: 1,
      ranking: {
        0: "冠军",
        1: "亚军",
        2: "季军"
      }
    });
    function showDetail(index) {
      state.currentIndex = index;
      state.showPreview = true;
    }
    watch(() => props.swiperSetInfo, newVal => {
      if (state.mySwiper) {
        // bool1代表是否销毁swiper实例
        // bool2代表是否销毁swiper样式（导航器、分页器等）
        state.mySwiper.destroy(true, false);
      }
      nextTick(() => {
        initSwiper(newVal.type, newVal.slidesPerView, newVal.initialSlide, newVal.spaceBetween);
        // state.mySwiper.update();
      });
    });

    function initSwiper(key, slidesIndex, initialIndex, spaceBetweenIndex) {
      state.mySwiper = new Swiper(`.${key}`, {
        observer: true,
        //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        //修改swiper的父元素时，自动初始化swiper
        slidesPerView: slidesIndex,
        initialSlide: initialIndex,
        //设定初始化时slide的索引,下标从0开始
        spaceBetween: spaceBetweenIndex,
        //间隔
        loop: true,
        // 是否循环轮播
        breakpoints: true,
        zoom: true,
        circular: true,
        // 是否采用衔接滑动
        parallax: true,
        centeredSlides: true,
        // 居中
        speed: 500,
        watchOverflow: true,
        //当没有足够的slide切换时,默认不开启这个功能
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          bulletClass: "swiper-pagination-bullet",
          //激活样式
          bulletActiveClass: "my-bullet-active"
        },
        on: {
          transitionStart() {
            // 开始translate之前触发
            // 如果是第一张
            if (this.activeIndex == 0) {
              this.setTranslate(0); // 设置位移为0
            }
          },

          click(e) {
            let index = e.target.dataset.itemindex;
            index && showDetail(index);
          }
        }
      });
    }
    onMounted(() => {
      if (props.swiperSetInfo.type) {
        initSwiper(props.swiperSetInfo.type, props.swiperSetInfo.slidesPerView, props.swiperSetInfo.initialSlide, props.swiperSetInfo.spaceBetween);
      }
    });
    return () => {
      var _props$zone1Teams$, _props$zone1Teams$2, _props$zone1Teams$3;
      console.log("props.zone1Teams===>", props.zone1Teams);
      return _createVNode("div", null, [_createVNode("div", {
        "class": `swiper-container ${props.swiperSetInfo.type} ${props.swiperSetInfo.key}`,
        "id": `${props.swiperSetInfo.type}`
      }, [_createVNode("div", {
        "class": "swiper-wrapper"
      }, [_createVNode("div", {
        "class": "swiper-slide"
      }, [_createVNode("div", {
        "class": "honor-box-3"
      }, [_createVNode("div", {
        "class": "team-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [(_props$zone1Teams$ = props.zone1Teams[1]) === null || _props$zone1Teams$ === void 0 ? void 0 : _props$zone1Teams$.name]), _createVNode("div", {
        "class": "qufu-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [props.zone1Teams[1].teamZoomName]), _createVNode("div", {
        "class": "detail-btn",
        "data-itemindex": 1
      }, null)])]), _createVNode("div", {
        "class": "swiper-slide"
      }, [_createVNode("div", {
        "class": "honor-box-2"
      }, [_createVNode("div", {
        "class": "team-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [(_props$zone1Teams$2 = props.zone1Teams[0]) === null || _props$zone1Teams$2 === void 0 ? void 0 : _props$zone1Teams$2.name]), _createVNode("div", {
        "class": "qufu-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [props.zone1Teams[0].teamZoomName]), _createVNode("div", {
        "class": "detail-btn",
        "data-itemindex": 0
      }, null)])]), _createVNode("div", {
        "class": "swiper-slide"
      }, [_createVNode("div", {
        "class": "honor-box-1"
      }, [_createVNode("div", {
        "class": "team-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [(_props$zone1Teams$3 = props.zone1Teams[2]) === null || _props$zone1Teams$3 === void 0 ? void 0 : _props$zone1Teams$3.name]), _createVNode("div", {
        "class": "qufu-name-title"
      }, null), _createVNode("div", {
        "class": "team-name"
      }, [props.zone1Teams[2].teamZoomName]), _createVNode("div", {
        "class": "detail-btn",
        "data-itemindex": 2
      }, null)])])]), _createVNode("div", {
        "class": "swiper-pagination"
      }, null)]), _createVNode(PreviewDialog, {
        "visible": state.showPreview,
        "onUpdate:visible": $event => state.showPreview = $event
      }, {
        default: () => [_createVNode("div", {
          "class": "preview-box"
        }, [_createVNode("div", {
          "class": "champion-name-box"
        }, [_createVNode("div", {
          "class": "champion-name-sub"
        }, [_createTextVNode("\u661F\u706B\u8054\u8D5B\u7B2C"), props.raceQuarter.value, _createTextVNode("\u5C4A "), props.groupType.label, " ", state.ranking[state.currentIndex]]), _createVNode("div", {
          "class": "champion-name"
        }, [props.zone1Teams[state.currentIndex].name, _createTextVNode(" \u6218\u961F")])]), _createVNode("div", {
          "class": "member-list-box"
        }, [_createVNode(MemberList, {
          "teamData": props.zone1Teams[state.currentIndex].members
        }, null), _createVNode("img", {
          "src": lineUrl
        }, null)])])]
      })]);
    };
  }
});